var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M6 18L18 6M6 6l12 12"}));
}

IconClose.defaultProps = {"fill":"none","stroke":"currentColor","className":"h-6 w-6 text-white","viewBox":"0 0 24 24"};

module.exports = IconClose;

IconClose.default = IconClose;
